/* eslint-disable react/jsx-no-useless-fragment */
import * as React from 'react';
import { useIsMobileDevice } from '../../../hooks';

interface IDeviceProps {
  mobile?: React.ReactNode;
  desktop?: React.ReactNode;
}

export const Device = ({ mobile = null, desktop = null }: IDeviceProps) => {
  const isMobile = useIsMobileDevice();

  if (isMobile) {
    return <>{mobile}</>;
  }

  return <>{desktop}</>;
};
